(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[�?o�?�"']/g, '')
      .trim();
  }

  function shouldHideDuplicateTitle(headingText, productTitle) {
    var heading = normalize(headingText);
    var title = normalize(productTitle);
    if (!heading || !title || heading.length < 6) return false;
    if (heading === title) return true;
    if (title.indexOf(heading + ' - ') === 0) return true;
    return false;
  }

  function firstMeaningfulElement(container) {
    var children = Array.prototype.slice.call(container.children || []);
    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];
      if (!child || child.hasAttribute('hidden')) continue;
      if (normalize(child.textContent)) return child;
    }
    return null;
  }

  function cleanup(root) {
    var scope = root || document;
    var titleEl = document.querySelector('[data-pawroutine-product-title-heading]') || document.querySelector('h1');
    var productTitle = titleEl ? titleEl.textContent : '';
    if (!productTitle) return;

    var contents = scope.querySelectorAll
      ? scope.querySelectorAll('.product-tab__content')
      : [];

    Array.prototype.forEach.call(contents, function (content) {
      var first = firstMeaningfulElement(content);
      if (!first || !/^H[12]$/i.test(first.tagName || '')) return;
      if (!shouldHideDuplicateTitle(first.textContent, productTitle)) return;
      first.setAttribute('hidden', 'hidden');
      first.setAttribute('aria-hidden', 'true');
      first.classList.add('pawroutine-hidden-duplicate-description-title');
    });
  }

  ready(function () { cleanup(document); });
  document.addEventListener('shopify:section:load', function (event) {
    cleanup(event.target);
  });
  document.addEventListener('variant:change', function () {
    window.setTimeout(function () { cleanup(document); }, 0);
  });
})();